import { e } from "./index834.mjs";
var r = e, o = r === "NODE";
export {
  o as e
};
